<div class="gc-square-icon gc-square-icon_{{ variant }}" [class.gc-circle-icon]="shape === 'circle'">
    <svg-icon [src]="ICONS_MAP[iconName]"></svg-icon>
</div>
